initSwiper(function() {

    var qtde_fotos = $('#swiperVeiculoZoom .foto_item').length;

    var swiperVeiculoDetalhe = new Swiper('.swiper-veiculo-detalhe', {
        loop: true,
        spaceBetween: 0, // Substitui margin: 0
        centeredSlides: false, // Equivalente ao center: true do Owl Carousel
        lazy: true, // Lazy load das imagens
        breakpoints: {
            598: {
                slidesPerView: 1, // Equivalente a autoWidth: true
                spaceBetween: 0, // Margem de 10px para telas acima de 598px
            },
            1000: {
                slidesPerView: 3, // Exibe 1 slide por vez
                spaceBetween: 10
            },
            1600: {
                slidesPerView: 4, // Exibe 1 slide por vez
                spaceBetween: 10
            }
        }
    });
    
    var swiperDicasSeg = new Swiper('.swiper-dicasseg', {
        loop: true,
        navigation: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true, // Se quiser habilitar pagina??o
        },
        autoplay: {
            delay: 5000, // 5 segundos
            disableOnInteraction: false, // Continua ap?s intera??o
        },
        spaceBetween: 0, // Substitui margin: 0
        centeredSlides: true, // Equivalente ao center: true do Owl Carousel
        lazy: true, // Lazy load das imagens
        breakpoints: {
            598: {
                slidesPerView: 1, // Equivalente a autoWidth: true
                spaceBetween: 0, // Margem de 10px para telas acima de 598px
            }
        }
    });

    $('#swiperVeiculoZoom').click(function(event) {
        event = event || window.event;
        if (!$(event.target).attr('src')) {
            event.preventDefault();
            return false;
        }
        var target = event.target || event.srcElement,
            link = target.src ? target.parentNode : target,
            options = {
                index: link.parentNode,
                event: event
            },
            links = $('#swiperVeiculoZoom').find('a');
        blueimp.Gallery(links, options);
    });

    if (qtde_fotos < 2) {
        $("#swiperVeiculoZoom .swiper-navigation").hide();
    }

    if ( ! $('body').hasClass('b-list')) {
        $("#blueimp-gallery").removeClass('d-none');
    }

    if (window.parent) {
        window.parent.$("#TB_ajaxWindowTitle").text('<?= $nameComMarca ?> - Detalhe do An?ncio');
        $(".mobile-back h2").html('<span>Voc? esta vendo o an?ncio:</span> <?= $nameSemMarca ?>');
    }

    if (IS_MOBILE) {
        $(".mobile-back").show();
        $(".mobile-back button").click(function(e) {
            e.preventDefault();
            if (document.referrer.indexOf(window.location.host) > -1) {
                window.close();
            } else {
                goToURL('http://' + window.location.host);
            }
        });
    }

    $("a.link-mapa").click(function() {
        $('#gmap_canvas').attr('src', $('#gmap_canvas').attr('data-mapasrc'));
        $(this).hide();
        $(".gmap_canvas").show();
    });

    checkSidebarAffix($('.detalhe-page').outerHeight()/* - $('.hideloadmore').outerHeight()*/);

    if ( (infoVeiculo && infoVeiculo.ativo == 'S') || params.moderando == 1) {
        registraStats.push([reportActions.DETALHE, 'V', infoVeiculo.id, infoVeiculo.revenda_id]);
    }

    $('.btnCloseMobile').on('click', function() {
        $('#enviarMsgMobile').addClass('d-none');
        $('#enviarWhatsMobile').addClass('d-none');
        $('#telefoneMobile').addClass('d-none');
    });

    setupSharing();

});